// Browser views must not reuse the short-lived signature saved with a stimulus,
// and some school web filters block storage.googleapis.com, so stimulus loads
// through the API. Keep the stored URL intact: AI providers still use its GCS
// object identity.
//
// A backend serves /files/stimulus from its own two buckets only (gcp.bucket.name
// and gcp.bucket.name.stimulus) and answers 400 for any other. So a link goes to
// the API only when that API's backend serves its bucket; any other link keeps
// its stored URL.
const stimulusBucketsByApiHost = {
  'api.gojeddle.com': ['handwritten-uploads', 'stimulus-uploads-prod'],
  'jeddai-backend-398731374434.australia-southeast1.run.app': [
    'handwritten-uploads-staging',
    'stimulus-uploads',
  ],
};
// Local and any other backend.
const defaultStimulusBuckets = [
  'handwritten_new',
  'handwritten-uploads-staging',
];

const apiBaseUrl = () =>
  (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080').replace(
    /\/+$/,
    ''
  );

const servedBuckets = (base) => {
  let host;
  try {
    host = new URL(base).host;
  } catch {
    host = '';
  }
  return new Set(
    [
      ...(stimulusBucketsByApiHost[host] || defaultStimulusBuckets),
      (process.env.REACT_APP_STIMULUS_UPLOAD_BUCKET || '').trim(),
    ].filter(Boolean)
  );
};

const uploadedName =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}_[^/\\\u0000-\u001f\u007f]+$/i;

export const stimulusFileUrl = (value) => {
  if (typeof value !== 'string') return value;
  try {
    const url = new URL(value);
    if (
      url.protocol !== 'https:' ||
      url.hostname !== 'storage.googleapis.com' ||
      url.port ||
      url.username ||
      url.password
    )
      return value;
    const base = apiBaseUrl();
    const [, bucket, ...segments] = url.pathname.split('/');
    if (!servedBuckets(base).has(bucket) || segments.length !== 1) return value;
    const blobName = decodeURIComponent(segments[0]);
    if (!uploadedName.test(blobName)) return value;
    return `${base}/files/stimulus?bucket=${encodeURIComponent(
      bucket
    )}&blobName=${encodeURIComponent(blobName)}`;
  } catch {
    return value;
  }
};
